import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Skeleton } from '@mui/material';
import { green, orange, red, grey } from '@mui/material/colors';
import api from '../../../services/api';

const barColor = (p) => p >= 98 ? green[600] : p >= 90 ? orange[500] : red[600];

// Componente parametrizado: passa `dimension` ('vendor' | 'type') e ele
// busca /coverage_by_{dimension} e desenha barras horizontais.
export default function CoverageBars({ dimension = 'vendor', title }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/hermes/dashboard/coverage_by_${dimension}`)
            .then(r => setRows(r.data || []))
            .finally(() => setLoading(false));
    }, [dimension]);

    return (
        <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" sx={{ fontFamily: 'Montserrat', fontWeight: 500, mb: 1.5 }}>
                {title}
            </Typography>
            {loading ? (
                <Skeleton variant="rectangular" height={180} />
            ) : rows.length === 0 ? (
                <Typography variant="body2" color="text.secondary">Nenhum dado.</Typography>
            ) : (
                <Box display="flex" flexDirection="column" gap={1.25}>
                    {rows.map((r, i) => (
                        <Box key={i}>
                            <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={0.25}>
                                <Typography variant="body2" fontWeight={600} noWrap>
                                    {r.name}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    <strong>{r.pct}%</strong> · {r.ok}/{r.total}
                                </Typography>
                            </Box>
                            <Box sx={{ height: 8, bgcolor: grey[100], borderRadius: 1, overflow: 'hidden' }}>
                                <Box sx={{
                                    height: '100%', width: `${Math.min(100, r.pct)}%`,
                                    bgcolor: barColor(r.pct),
                                    borderRadius: 1, transition: 'width .3s',
                                }} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            )}
        </Paper>
    );
}
